import { Booking } from 'components/EventCalendar/types';
import moment from 'moment';

interface Props {
    booking: Booking;
}

/** When the booking came in: date on top, time below. */
export const BookingMetaComponent = ({ booking }: Props) => (
    <div className="tw-flex tw-flex-col tw-leading-5">
        <span className="tw-tabular-nums">{moment(booking.created_at).format('DD.MM.YY')}</span>
        <span className="tw-text-xs tw-tabular-nums tw-leading-4 tw-text-accents-6">
            {moment(booking.created_at).format('HH:mm')}
        </span>
    </div>
);
